import React, { useState, useEffect } from 'react';
import {
  Grid, TextField, Button, Typography, MenuItem, Select, Chip, InputLabel, FormControl, Checkbox, ListItemText, Autocomplete, Box, Paper, Dialog, DialogActions, DialogTitle, DialogContent
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import apiService from '../../service/apiService';
import { FormHelperText } from "@mui/material";

const AddTechnologyPark = () => {
  const navigate = useNavigate();
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);
  const [blk, setBlk] = useState(loginData?.blockId ? loginData.blockId : 0);
  const isDistCoordinator = loginData?.districtCoordinatorsId !== null;
  const isBlockCoordinator = loginData?.blockCoordinatorsId !== null;

  const [formData, setFormData] = useState({
    yearId: '',
    seasonId: '',
    districtId: dist || '',
    blockId: blk || '',
    mipIds: [],
    seedshowingdate: '',
    location: '',
    seedIds: [],
    variety: [],
    plotSize: '',
    producerGroupIds: [],
    farmerIds: [],
    climateSmartCharacteristics: '',
    designations: '',
    resourcePersonName: '',
    visitors: 0,
  });

  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [mips, setMips] = useState([]);
  const [crops, setCrops] = useState([]);
  const [varieties, setVarieties] = useState([]);
  const [producerGroups, setProducerGroups] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [errors, setErrors] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [varietyData, setVarietyData] = useState({});
  const [savedData, setSavedData] = useState([]);
  const [isReplicationEnabled, setIsReplicationEnabled] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === 'mipIds' || name === 'producerGroupIds' || name === 'farmerIds' || name === 'seedVarietyIds'
        ? value
        : value,
    }));

    if (name === 'seedIds') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: Array.isArray(value) ? value : [value],
      }));
    }
    if (name === 'producerGroupIds') {
      fetchFarmers(value);
    }
  };

  const fetchFarmers = (selectedProducerGroupIds) => {
    if (selectedProducerGroupIds.length === 0) {
      setFarmers([]);
      return;
    }
    apiService.post('/farmers/detail', {
      ProducerGroupId: selectedProducerGroupIds,
    })
      .then((response) => setFarmers(response.data))
      .catch((error) => console.error('Error fetching farmer data:', error));
  };

  const fetchBlocks = async (districtId) => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${districtId}`);
      if (response.data.status) {
        setBlocks(response.data.body.blocks);
      } else {
        setBlocks([]);
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      setBlocks([]);
    }
  };

  const fetchMIP = async (blockId) => {
    try {
      const response = await apiService.get(`/master/get-mip-by-block/${blockId}`);
      setMips(response.data.body);
    } catch (error) {
      console.error("Error fetching MIPs:", error);
    }
  };

  const fetchPg = async (blockId) => {
    try {
      const response = await apiService.get(`/master/get-pg-by-block/${blockId}`);
      setProducerGroups(response.data.body);
    } catch (error) {
      console.error("Error fetching producer groups:", error);
    }
  };

  useEffect(() => {
    if (formData.blockId) {
      fetchMIP(formData.blockId);
      fetchPg(formData.blockId);
    }
  }, [formData.blockId]);

  useEffect(() => {
    if (formData.districtId) {
      fetchBlocks(formData.districtId);
    }
  }, [formData.districtId]);

  const handleVarietyChange = (e) => {
    const selectedVarieties = e.target.value;
    setFormData({ ...formData, variety: selectedVarieties });
    setIsReplicationEnabled(selectedVarieties.length > 0);

    const updatedVarietyData = selectedVarieties.reduce((acc, SeedVarietyId) => {
      if (!acc[SeedVarietyId]) {
        acc[SeedVarietyId] = { yieldPerPlot: '', yieldPerHectare: '', noofreplication: '' };
      }
      return acc;
    }, {});

    setVarietyData({ ...varietyData, ...updatedVarietyData });
  };

  const handleYieldChange = (SeedVarietyId, field, value) => {
    setVarietyData((prev) => {
      const updatedData = { ...prev[SeedVarietyId] };

      if (field === "yieldPerPlot") {
        const yieldPerPlot = parseFloat(value) || 0;
        updatedData.yieldPerPlot = value;
        updatedData.yieldPerHectare = (yieldPerPlot * 4).toFixed(2);
      } else if (field === "noofreplication") {
        updatedData.noofreplication = value;
      }

      return {
        ...prev,
        [SeedVarietyId]: updatedData,
      };
    });
  };

  const handleSaveData = () => {
    const newSavedData = formData.variety.map((SeedVarietyId) => ({
      varietyName: varieties.find((v) => v.seedVarietyId === SeedVarietyId)?.varietyName,
      yieldPerPlot: varietyData[SeedVarietyId]?.yieldPerPlot || '',
      yieldPerHectare: varietyData[SeedVarietyId]?.yieldPerHectare || '',
      noofreplication: varietyData[SeedVarietyId]?.noofreplication || 0,
    }));

    setSavedData(newSavedData);
    setOpenDialog(false);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.yearId) newErrors.yearId = "Year is required";
    if (!formData.seasonId) newErrors.seasonId = "Season is required";
    if (!formData.districtId) newErrors.districtId = "District is required";
    if (!formData.blockId) newErrors.blockId = "Block is required";
    if (!formData.mipIds || formData.mipIds.length === 0) newErrors.mipIds = "At least one MIP is required";
    if (!formData.seedshowingdate) newErrors.seedshowingdate = "Date is required";
    if (!formData.location) newErrors.location = "Location is required";
    if (!formData.seedIds || formData.seedIds.length === 0) newErrors.seedIds = "Crop is required";
    if (!formData.variety || formData.variety.length === 0) newErrors.variety = "At least one variety is required";
    if (!formData.plotSize) newErrors.plotSize = "Plot size is required";
    if (!formData.producerGroupIds || formData.producerGroupIds.length === 0) newErrors.producerGroupIds = "At least one Producer Group is required";
    if (!formData.farmerIds || formData.farmerIds.length === 0) newErrors.farmerIds = "At least one Farmer is required";
    if (!formData.climateSmartCharacteristics) newErrors.climateSmartCharacteristics = "Climate Smart Characteristics is required";
    if (!formData.resourcePersonName) newErrors.resourcePersonName = "Resource Person Name is required";
    if (!formData.designations) newErrors.designations = "Designation is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const isConfirmed = window.confirm("Are you sure you want to add this Technology Park?");
    if (!isConfirmed) {
      return;
    }

    const replications = formData.variety.map((SeedVarietyId) => ({
      SeedVarietyId,
      yieldPerPlot: varietyData[SeedVarietyId]?.yieldPerPlot || '',
      YieldPerHaInQtl: varietyData[SeedVarietyId]?.yieldPerHectare || '',
      NoOfReplication: Number(varietyData[SeedVarietyId]?.noofreplication) || 0,
    }));

    const payload = {
      YearId: formData.yearId,
      Location: formData.location,
      Date: formData.seedshowingdate,
      PlotSize: formData.plotSize,
      ClimateSmartCharacteristics: formData.climateSmartCharacteristics,
      ResourcesName: formData.resourcePersonName,
      Designation: formData.designations,
      SeasonId: formData.seasonId,
      BlockId: formData.blockId,
      DistrictId: formData.districtId,
      ProducerGroupIds: formData.producerGroupIds,
      MIPIds: formData.mipIds,
      FarmerIds: formData.farmerIds,
      SeedIds: formData.seedIds,
      ReplicationDetails: replications,
      visitors: Number(formData.visitors) || 0
    };

    try {
      const response = await apiService.post('/technology/create', payload);

      if (response.status === 200) {
        alert('Technology Park added successfully!');
        navigate(-1);
      } else {
        alert('Error adding Technology Park. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred while submitting the form. Please try again.');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    apiService.get('/years/get-all')
      .then(response => setYears(response.data))
      .catch(error => console.error("Error fetching years:", error));

    apiService.get('/seasons/get-all')
      .then(response => setSeasons(response.data))
      .catch(error => console.error("Error fetching seasons:", error));

    apiService.get('/districts/get-all')
      .then(response => setDistricts(response.data))
      .catch(error => console.error('Error fetching districts:', error));

    apiService.get('/seeds/get-all')
      .then(response => setCrops(response.data))
      .catch(error => console.error("Error fetching crops:", error));

    apiService.get('/seed-varieties/get-all')
      .then(response => setVarieties(response.data))
      .catch(error => console.error("Error fetching seed varieties:", error));
  }, []);

  return (
    <div className="container-fluid p-4" style={{ maxHeight: "100vh", overflowX: "auto", backgroundColor: "#f8f9fa" }}>
      <div className="mx-3 mt-2 d-flex justify-content-between align-items-center">
        <Typography variant="h4" gutterBottom>
          Add Technology Park
        </Typography>
        <p><span className='text-danger text-bold' style={{ fontSize: "18px" }}>*</span> mark fields are mandatory</p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Section 1: Basic Information */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Basic Information
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.yearId}>
                <InputLabel id="year-label">
                  Year <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="year-label"
                  name="yearId"
                  value={formData.yearId || ""}
                  onChange={handleChange}
                  label="Year *"
                >
                  {years.map((year) => (
                    <MenuItem key={year.yearId} value={year.yearId}>
                      {year.yearValue}
                    </MenuItem>
                  ))}
                </Select>
                {errors.yearId && <FormHelperText>{errors.yearId}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.seasonId}>
                <InputLabel id="season-label">
                  Season <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="season-label"
                  name="seasonId"
                  value={formData.seasonId || ""}
                  onChange={handleChange}
                  label="Season *"
                >
                  {seasons.map((season) => (
                    <MenuItem key={season.seasonId} value={season.seasonId}>
                      {season.seasonName}
                    </MenuItem>
                  ))}
                </Select>
                {errors.seasonId && <FormHelperText>{errors.seasonId}</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        {/* Section 2: Location Details */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Location Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={districts}
                getOptionLabel={(option) => option.districtName || ""}
                value={districts.find((district) => district.districtId === formData.districtId) || null}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    districtId: newValue ? newValue.districtId : "",
                    blockId: "",
                  }));
                  if (newValue) fetchBlocks(newValue.districtId);
                }}
                disabled={isDistCoordinator}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>District <span style={{ color: "red" }}>*</span></>}
                    error={!!errors.districtId}
                    helperText={errors.districtId}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={blocks}
                getOptionLabel={(option) => option.blockName || ""}
                value={blocks.find((block) => block.blockId === formData.blockId) || null}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    blockId: newValue ? newValue.blockId : "",
                  }));
                }}
                disabled={isBlockCoordinator}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>Block <span style={{ color: "red" }}>*</span></>}
                    error={!!errors.blockId}
                    helperText={errors.blockId}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={mips}
                getOptionLabel={(option) => option.mipname || ""}
                multiple
                value={mips.filter((mip) => formData.mipIds.includes(mip.mipid))}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    mipIds: newValue.map((mip) => mip.mipid),
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>MIP <span style={{ color: "red" }}>*</span></>}
                    error={!!errors.mipIds}
                    helperText={errors.mipIds}
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Section 3: Crop & Field Details */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Crop & Field Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                options={crops}
                getOptionLabel={(option) => option.seedName || ""}
                value={crops.find((seed) => formData.seedIds.includes(seed.seedId)) || null}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    seedIds: newValue ? [newValue.seedId] : [],
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>Crop <span style={{ color: "red" }}>*</span></>}
                    error={!!errors.seedIds}
                    helperText={errors.seedIds}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth error={!!errors.variety}>
                <InputLabel>Variety <span style={{ color: "red" }}>*</span></InputLabel>
                <Select
                  label="Variety *"
                  name="variety"
                  multiple
                  value={formData.variety}
                  onChange={handleVarietyChange}
                  renderValue={(selected) => {
                    return varieties
                      .filter((variety) => selected.includes(variety.seedVarietyId))
                      .map((variety) => variety.varietyName)
                      .join(', ');
                  }}
                >
                  {varieties.map((variety) => (
                    <MenuItem key={variety.seedVarietyId} value={variety.seedVarietyId}>
                      <Checkbox checked={formData.variety.includes(variety.seedVarietyId)} />
                      <ListItemText primary={variety.varietyName} />
                    </MenuItem>
                  ))}
                </Select>
                {errors.variety && <FormHelperText>{errors.variety}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Date *"
                name="seedshowingdate"
                type="date"
                value={formData.seedshowingdate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                error={!!errors.seedshowingdate}
                helperText={errors.seedshowingdate}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Location *"
                name="location"
                value={formData.location}
                onChange={handleChange}
                error={!!errors.location}
                helperText={errors.location}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Plot Size *"
                name="plotSize"
                value={formData.plotSize}
                onChange={handleChange}
                error={!!errors.plotSize}
                helperText={errors.plotSize}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Climate Smart Characteristics *"
                name="climateSmartCharacteristics"
                value={formData.climateSmartCharacteristics}
                onChange={handleChange}
                error={!!errors.climateSmartCharacteristics}
                helperText={errors.climateSmartCharacteristics}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Section 4: Replication Details */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Replication Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {savedData.length > 0 ? (
                <div onClick={isReplicationEnabled ? handleDialogOpen : null} style={{ cursor: isReplicationEnabled ? 'pointer' : 'default' }}>
                  <Typography variant="h6">Saved Yield Data</Typography>
                  {savedData.map((data, index) => (
                    <div key={index} style={{ marginBottom: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                      <Typography variant="body1">
                        <strong>{data.varietyName}</strong>
                      </Typography>
                      <Typography variant="body2">
                        Yield per Plot: {data.yieldPerPlot}
                      </Typography>
                      <Typography variant="body2">
                        Yield per Hectare: {data.yieldPerHectare}
                      </Typography>
                      <Typography variant="body2">
                        No of Replication: {data.noofreplication}
                      </Typography>
                    </div>
                  ))}
                </div>
              ) : (
                <TextField
                  fullWidth
                  label="No. of Replication"
                  name="numReplication"
                  value={formData.numReplication || ''}
                  onChange={(e) =>
                    setFormData({ ...formData, numReplication: e.target.value })
                  }
                  onClick={isReplicationEnabled ? handleDialogOpen : null}
                  disabled={!isReplicationEnabled}
                  placeholder={!isReplicationEnabled ? "Select varieties first" : "Click to add replication details"}
                />
              )}
            </Grid>
          </Grid>
        </Paper>

        {/* Section 5: Participants Information */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Participants Information
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                multiple
                options={producerGroups}
                getOptionLabel={(option) => option.pgName || ""}
                value={producerGroups.filter(group => formData.producerGroupIds?.includes(group.producerGroupId)) || []}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    producerGroupIds: newValue.map((group) => group.producerGroupId),
                  }));
                  fetchFarmers(newValue.map((group) => group.producerGroupId));
                }}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip key={option.producerGroupId} label={option.pgName} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>Producer Group <span style={{ color: "red" }}>*</span></>}
                    fullWidth
                    error={Boolean(errors.producerGroupIds)}
                    helperText={errors.producerGroupIds}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                multiple
                options={farmers}
                getOptionLabel={(option) => option.FarmerName}
                value={farmers.filter(farmer => formData.farmerIds.includes(farmer.FarmerId))}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    farmerIds: newValue.map((farmer) => farmer.FarmerId),
                  }));
                }}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip key={option.FarmerId} label={option.FarmerName} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>Farmer <span style={{ color: "red" }}>*</span></>}
                    fullWidth
                    error={Boolean(errors.farmerIds)}
                    helperText={errors.farmerIds}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Section 6: Resource Person Details */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Resource Person Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={<>Resource Person Name <span style={{ color: "red" }}>*</span></>}
                name="resourcePersonName"
                value={formData.resourcePersonName}
                onChange={handleChange}
                error={!!errors.resourcePersonName}
                helperText={errors.resourcePersonName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={<>Designation <span style={{ color: "red" }}>*</span></>}
                name="designations"
                value={formData.designations}
                onChange={handleChange}
                error={!!errors.designations}
                helperText={errors.designations}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Visitor(no.)"
                name="visitors"
                type="number"
                value={formData.visitors}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Yield Data Dialog */}
        <Dialog open={openDialog} onClose={handleDialogClose} fullWidth>
          <DialogTitle>Yield Data</DialogTitle>
          <DialogContent>
            {formData.variety.map((SeedVarietyId) => {
              const variety = varieties.find((v) => v.seedVarietyId === SeedVarietyId);
              return (
                <div key={SeedVarietyId} style={{ marginBottom: '16px' }}>
                  <h4>{variety?.varietyName}</h4>
                  <TextField
                    fullWidth
                    label="Yield per Plot"
                    value={varietyData[SeedVarietyId]?.yieldPerPlot || ''}
                    onChange={(e) => handleYieldChange(SeedVarietyId, "yieldPerPlot", e.target.value)}
                    style={{ marginBottom: '8px' }}
                  />
                  <TextField
                    fullWidth
                    label="Yield per Hectare"
                    value={varietyData[SeedVarietyId]?.yieldPerHectare || ''}
                    disabled
                    style={{ marginBottom: '8px' }}
                  />
                  <TextField
                    fullWidth
                    label="No of Replication"
                    value={varietyData[SeedVarietyId]?.noofreplication || ''}
                    onChange={(e) => handleYieldChange(SeedVarietyId, "noofreplication", e.target.value)}
                    style={{ marginBottom: '8px' }}
                  />
                </div>
              );
            })}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancel</Button>
            <Button onClick={handleSaveData}>Save</Button>
          </DialogActions>
        </Dialog>

        {/* Submit Buttons */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Box>
      </form>
    </div>
  );
};

export default AddTechnologyPark;